import type { FaireProductEntity } from "../../entity_types/product";

export const p_b66ftcnywr: FaireProductEntity = {
  token: "p_b66ftcnywr",
  type: "product",
  name: 'Brass Chamberstick Taper Candle Holder 3.25" Wide X 2.25" Hi',
  brandName: "GREENROOTS USA LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/0d843972cd9b699b062016467f562eff67cd394c0c92f89e4d46d8918a9d5a1c.jpeg",
  priceDollars: 11.99,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/b03485d39d9b74cca897723e58bdccd91d2ab1a1c30de9d500a376d313b60731.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
